<template>
  <div class="login_box">
    <div class="login_box_title">{{$vi18n('$i18n# 迷你账号登录 #i18n$')}}</div>
    <el-form
      :model="loginForm"
      :rules="loginRules"
      ref="loginForm"
      @keyup.enter.native="handleLogin"
      label-width="36px"
    >
      <el-form-item prop="uin">
        <el-input
          v-model="loginForm.uin"
          class="login_name"
          :placeholder="$vi18n('$i18n# 输入您的迷你号 #i18n$')"
        >
          <i slot="prefix" class="account"></i>
          <template slot="append" v-if="isCodeLogin">
            <CountDown
              :defaultText="$vi18n('$i18n# 获取验证码 #i18n$')"
              @click="handleSendCode"
            ></CountDown>
          </template>
        </el-input>
      </el-form-item>
      <!-- $vi18n('$i1n# 验证码登录 #i18n$') -->
      <el-form-item v-if="isCodeLogin" prop="authcode">
        <el-input
          v-model="loginForm.authcode"
          type="text"
          class="login_pass"
          :placeholder="$vi18n('$i18n# 请输入您收到的验证码 #i18n$')"
        >
          <i slot="prefix" class="pass"></i>
          <el-tooltip
            placement="bottom-start"
            slot="suffix"
            style="margin-right: 10px"
          >
            <div slot="content">{{$vi18n('$i18n# 验证码登录 #i18n$')}}：{{$vi18n('$i18n# 验证码会发送至您的游戏邮箱 #i18n$')}}</div>
            <div class="logo"><i class="el-icon-question"></i></div>
          </el-tooltip>
        </el-input>
      </el-form-item>
      <!-- $vi18n('$i1n# 密码登录 #i18n$') -->
      <el-form-item v-else prop="pw">
        <el-input
          v-model="loginForm.pw"
          type="password"
          class="login_pass"
          :placeholder="$vi18n('$i18n# 输入您的迷你号密码 #i18n$')"
        >
          <i slot="prefix" class="pass"></i>
        </el-input>
      </el-form-item>
      <el-form-item class="code-wrap" prop="icode">
        <el-input
          v-model="loginForm.icode"
          type="text"
          class="login_piccode"
          :placeholder="$vi18n('$i18n# 请输入图片验证码 #i18n$')"
        >
        </el-input>
        <div class="picture-code" @click="updateCode">
          <img :src="codePicture" />
        </div>
      </el-form-item>
      <div class="login-btn">
        <span @click="handleChangeLoginType">{{ loginType }}</span>
      </div>
      <el-form-item>
        <el-button
          v-loading="isLogining"
          type="warning"
          class="login_btn"
          @click="handleLogin"
          :disabled="!isAgree"
          >{{$vi18n('$i18n# 登录 #i18n$')}}</el-button
        >
      </el-form-item>
    </el-form>
    <!-- <div class="login_box_bottom">
      <el-checkbox v-model="isAgree">{{$vi18n('$i18n# 我已经详细阅读并同意 #i18n$')}}</el-checkbox>
      <el-link
        :underline="false"
        href="https://www.mini1.cn/privacy_policy.html"
        type="primary"
        target="_blank"
        >《{{$vi18n('$i18n# 隐私政策 #i18n$')}}》</el-link
      >
     {{ $vi18n('$i18n# 和 #i18n$')}}
      <el-link
        :underline="false"
        type="primary"
        target="_blank"
        href="https://mnweb.mini1.cn/activity/docs/mini1_platform_user_protocol_F20210623_final.htm"
        >《{{$vi18n('$i18n# 迷你平台用户协议 #i18n$')}}》</el-link
      >
    </div> -->
    <el-dialog
      :title="$vi18n('$i18n# 验证身份 #i18n$')"
      append-to-body
      :visible.sync="emailLoginDialog.visible"
      destroy-on-close
      width="600px"
    >
      <EmailLogin :data="emailLoginDialog.data" @loginSuccess="handleLoginSuccess"></EmailLogin>
    </el-dialog>
  </div>
</template>
<script>
import CountDown from './CountDown';
import EmailLogin from './EmailLogin';
import { $vi18n } from '@/utils/i18n.js';
import {
  loginWithPwd,
  getLoginCode,
  loginWithCode,
  getPicCode,
  repeatCertify,
} from '@/api/common';
import {
  neatedLoginUserInfo,
  setUserInfoInStorage,
  renameLoginTitle,
  isInGame,
} from '@/utils';
import { encryptPwd } from '@/utils/crypto';
let isFromCreatorbbs = false;
let redirectUrl = location.href.split('?')[1];
if (redirectUrl && ~redirectUrl.indexOf('redirectUrl=')) {
  const _arr = redirectUrl.split('&');
  redirectUrl = _arr
    .filter(val => ~val.indexOf('redirectUrl'))[0]
    .split('=')[1];
  redirectUrl = decodeURIComponent(redirectUrl);
  if (/https:\/\/kfz(-test)?.mini1.cn\/creatorbbs\//.test(redirectUrl)) {
    renameLoginTitle($vi18n('$i18n# 创作者社区 #i18n$'));
    isFromCreatorbbs = true;
  }
} else {
  redirectUrl = null;
}
export default {
  components: {
    CountDown,
    EmailLogin
  },
  data() {
    return {
      loginForm: {
        uin: process.env.VUE_APP_ENV === 'dev' ? '1000046646' : '',
        pw: process.env.VUE_APP_ENV === 'dev' ? 'mini123456' : '',
        // uin: process.env.VUE_APP_ENV === 'dev' ? '1000045867' : '',
        // pw: process.env.VUE_APP_ENV === 'dev' ? 'Syj158390#' : '',
        icode: '',
        authcode: '',
        id: '',
      },
      codePicture: '',
      isAgree: true,
      isCodeLogin: false,
      loginType: this.$vi18n('$i18n# 验证码登录 #i18n$'),
      isLogining: false,
      emailLoginDialog: {
        data: null,
        visible: false
      }
    };
  },
  computed: {
    // $vi18n('$i18n# 动态计算规则 #i18n$')
    loginRules() {
      let rules = {
        uin: [{ required: true, message: this.$vi18n('$i18n# 请输入迷你号 #i18n$') }],
      };
      if (this.isCodeLogin) {
        rules.authcode = [{ required: true, message: this.$vi18n('$i18n# 请输入您收到的验证码 #i18n$') }];
        rules.icode = [{ required: true, message: this.$vi18n('$i18n# 请输入图片验证码 #i18n$') }];
      } else {
        rules.pw = [{ required: true, message: this.$vi18n('$i18n# 请输入密码 #i18n$') }];
        rules.icode = [{ required: true, message: this.$vi18n('$i18n# 请输入图片验证码 #i18n$') }];
      }
      return rules;
    },
  },
  mounted() {
    this.updateCode();
  },
  methods: {
    // $vi18n('$i18n# 切换登录方式 #i18n$')
    handleChangeLoginType() {
      this.isCodeLogin = !this.isCodeLogin;
      this.loginType = this.isCodeLogin ? this.$vi18n('$i18n# 密码登录 #i18n$') : this.$vi18n('$i18n# 验证码登录 #i18n$');

      this.$refs.loginForm.clearValidate();
    },
    // $vi18n('$i18n# 获取验证码 #i18n$')
    async handleSendCode(callback) {
      // 屏蔽验证码登录 #i18n$')
      this.$message.error(this.$vi18n('$i18n# 系统维护中 #i18n$'));
      // const { uin, icode, id } = this.loginForm;

      // if (!uin) {
      //   return this.$message.error(this.$vi18n('$i18n# 请输入迷你号 #i18n$'));
      // } else if (!icode) {
      //   return this.$message.error(this.$vi18n('$i18n# 请输入图片验证码 #i18n$'));
      // }
      // // let res = await getLoginCode({ uin, icode });
      // try {
      //   await getLoginCode({ uin: this.getServeUin(uin), icode, id });
      //   this.$message.success(this.$vi18n('$i18n# 验证码已发送至您的游戏邮箱 #i18n$'));
      //   typeof callback === 'function' && callback();
      //   this.updateCode();
      // } catch (e) {
      //   this.updateCode();
      // }
      // console.log('code', res.code);
      // this.$message.success('$vi18n('$in# 验证码已发送至您的游戏邮箱 #i18n$')');
      //  typeof callback === 'function' && callback();
    },
    //$vi18n('$i18n# 刷新图片验证码 #i18n$')
    async updateCode() {
      const res = await getPicCode();
      let newStr = String(res.data.image);
      // eslint-disable-next-line no-useless-escape
      // newStr.replaceAll('\/', '/');
      // eslint-disable-next-line no-useless-escape
      newStr.replace(new RegExp('\/', 'g'), '/'); //replace$vi18n('$8n# 部分浏览器不适用 #i18n$')
      this.codePicture = 'data:image/png;base64,' + newStr;
      this.loginForm.id = res.data.id;
    },
    getServeUin (uin) {
      uin = String(uin);
      const len = uin.length;
      if (len >= 10) {
        return uin;
      } else {
        let diff = 10 - len - 1;
        let pre = '1';
        while (diff --) {
          pre += '0';
        }
        return pre + uin;
      }
    },
    showEmailLoginDialog(data) {
      const params = {
        uin: this.loginForm.uin,
        ct: Math.floor(new Date().getTime() / 1000)
      }
      this.emailLoginDialog.data = Object.assign(params, data)
      this.emailLoginDialog.visible = true
    },
    // $vi18n('$i8# 登录 #i18n$')
    async handleLogin() {
      // if (!this.isAgree) {
      //   return this.$message.error(
      //     `${this.$vi18n('$i18n# 请阅读 #i18n$')《$vi18n('$i18n# 隐私政策 #i18n$')》$vi18n('$i18n# 和 #i18n$')《$vi18n('$i18n# 迷你平台用户协议 #i18n$')》$vi18n('$i18n# 并勾选同意 #i18n$')}`,
      //   );
      // }
      // $vi18n('$8n# 校验 #i18n$')
      this.$refs.loginForm.validate(async valid => {
        if (!valid) return;

        try {
          const loginMethod = this.isCodeLogin ? loginWithCode : loginWithPwd;
          const { uin, pw, authcode, icode, id } = this.loginForm;
          let params = { uin: this.getServeUin(uin), icode, id };
          // $vi18n('$in# 如果是密码登录 #i18n$')，$vi18n('$8n# 需要加密 #i18n$')
          if (this.isCodeLogin) {
            params.authcode = authcode;
          } else {
            params.pw = encryptPwd(pw);
          }
          //sessionStorage.clear();
          this.isLogining = true;
          const { data } = await loginMethod(params);
          this.isLogining = false;
          // 需要邮箱验证码二次验证 #i18n$')
          if (!this.isCodeLogin && data.email_login_token) {
            this.showEmailLoginDialog(data)
            return
          }
          // $vi18n('$in# 存储用户信息 #i18n$')
          this.handleLoginSuccess(data)
        } catch (err) {
          console.error(err);
          this.isLogining = false;
          this.updateCode();
        }
      });
    },
    handleLoginSuccess(data) {
      if (this.emailLoginDialog.visible === true) {
        this.emailLoginDialog.visible = false
      }
      const userInfo = setUserInfoInStorage(neatedLoginUserInfo(data));
      window.MiniService.UserService.init(isInGame ? 1 : 2, userInfo);
      sessionStorage.removeItem('setible');
      sessionStorage.removeItem('token2');
      this.$router.push('/', () => location.reload());
    }
  },
};
</script>

<style lang="scss" scoped>
.login_box {
  position: relative;
  top: 201px;
  left: 50%;
  margin-left: -175px;
  width: 350px;
  height: 400px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(217, 217, 217, 1);
  border-radius: 8px;
  .el-form-item.code-wrap {
    //  margin-left: 36px !important;
    //width: 282px;
    display: flex;
    margin-bottom: 14px;
    /deep/.el-form-item__content {
      display: flex;
      width: 100%;
      height: 45px;
    }
    .el-input {
      width: 200px;
    }
    .picture-code {
      width: 70px;
    }
    img {
      height: 38px;
      width: 70px;
      margin-left: 10px;
      cursor: pointer;
    }
  }
}

.login_box_bottom {
  position: absolute;
  bottom: 0;
  width: 348px;
  height: 66px;
  background: rgba(243, 248, 255, 1);
  border: 1px solid rgba(217, 217, 217, 1);
  opacity: 1;
  border-radius: 0px 0px 8px 8px;
  padding: 12px 24px;
  font-size: 14px;
  line-height: 24px;
  .el-link {
    color: #2b6ddf;
    &:hover {
      color: #2b6ddf;
    }
  }
}

.login_box_title {
  width: 350px;
  font-size: 20px;
  font-weight: bold;
  color: rgba(38, 38, 38, 1);
  text-align: center;
  margin-top: 40px;
}

.el-input {
  width: 282px;
  height: 40px;
}

.login_name {
  margin-top: 40px;
}

.login-btn {
  text-decoration: none;
  display: block;
  text-align: center;
  color: #2b6ddf;
  font-size: 14px;

  > span {
    cursor: pointer;
    user-select: none;
  }
}

.login_btn {
  width: 282px;
  height: 40px;
  margin-top: 15px;
}

.code {
  cursor: pointer;
  width: 110px;
  color: #fd9b21 !important;
}

.uncode {
  cursor: pointer;
  width: 110px;
  color: #bfbfbf !important;
}

.account {
  background: url('~@/assets/images/ico_account.svg') no-repeat;
  width: 16px;
  height: 16px;
  background-size: 16px 16px;
  display: block;
  margin-top: 11px;
}

.pass {
  background: url('~@/assets/images/ico_password.svg') no-repeat;
  width: 16px;
  height: 16px;
  background-size: 16px 16px;
  display: block;
  margin-top: 11px;
}
@media screen and (max-width: 980px) {
  .login_box {
    position: relative;
    top: 17%;
    left: 50%;
    margin-left: -160px;
    width: 320px;
    height: 455px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(217, 217, 217, 1);
    border-radius: 8px;
    ::v-deep.el-form-item__content {
      margin-left: 18px !important;
    }
  }
  .login_box_bottom {
    position: absolute;
    bottom: 0;
    width: 320px;
    height: 66px;
    background: rgba(243, 248, 255, 1);
    border: 1px solid rgba(217, 217, 217, 1);
    opacity: 1;
    border-radius: 0px 0px 8px 8px;
    padding: 12px 24px;
    font-size: 14px;
    line-height: 24px;
    .el-link {
      color: #2b6ddf;
      &:hover {
        color: #2b6ddf;
      }
    }
  }
  // ::v-deep.el-form-item__content {
  //   display: flex;
  //   width: 100%;
  //   height: 45px;
  // }
}
</style>
